import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Button, Label, Form, FormGroup, Col } from 'reactstrap';
import './ChangeAnchorModal.css';
import FormWrapper from './../../commonComponents/formWrapper/FormWrapper.container';
import _ from 'lodash';
import { sharedLabelsPath } from "../../../reducers/common/localization";
import SelectWithSearch from "../../commonComponents/selectWithSearch/SelectWithSearch";

class ChangeAnchorModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            employeeId: null
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.isOpen && nextProps.isOpen){
            this.props.onEmployeesLoad();
        }
    }

    render() {
        return (
            <Modal className='change-anchor-modal' isOpen={this.props.isOpen} toggle={this.handleCancel}>
                <ModalBody>
                    <FormWrapper
                        successMessage={_.get(this.props.translation, 'org_staff.change_anchor.success_message')}
                    >
                        <div className='change-anchor-modal-alert-message'>{_.get(this.props.translation, 'org_staff.change_anchor.modal_alert_message')}</div>
                        <div className="change-anchor-warning">{_.get(this.props.translation, 'org_staff.change_anchor.modal_alert_warning')}</div>
                        <Form onSubmit={this.onSubmit}>
                            <FormGroup row>
                                <Label sm={3}>{_.get(this.props.translation, 'org_staff.accreditation_groups.employee_label')}</Label>
                                <Col sm={9}>
                                    <SelectWithSearch
                                        value={this.state.employeeId}
                                        onChange={this.handleChangeEmployeeId}
                                        options={this.getEmployeesOptions()}
                                        placeholder={_.get(this.props.translation, 'org_staff.accreditation_groups.employee_input_placeholder')}
                                    />
                                </Col>
                            </FormGroup>
                            <div className="modal-buttons-container">
                                <Button color="secondary" onClick={this.handleCancel}>
                                    {_.get(this.props.translation, sharedLabelsPath.cancel_button)}
                                </Button>
                                <Button className="olive-green-btn" type='submit' disabled={_.isNil(this.state.employeeId)}>
                                    {_.get(this.props.translation, 'org_staff.change_anchor.submit_button')}
                                </Button>
                            </div>
                        </Form>
                    </FormWrapper>
                </ModalBody>
            </Modal>
        );
    }

    handleChangeEmployeeId = (value) => {
        this.setState({ employeeId: value });
    };

    getEmployeesOptions = () => {
        return _.map(this.props.availableStaffMembers, employee => (
            { value: employee.id, label: `${employee.firstName} ${employee.lastName} (${employee.email})` }
        ));
    };

    onSubmit = (e) => {
        e.preventDefault();

        this.props.onChangeAnchor(this.state.employeeId);
    };

    handleCancel = () => {
        this.setState({
            employeeId: null
        });
        this.props.onCancel();
    }
}

ChangeAnchorModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    availableStaffMembers: PropTypes.array,
    translation: PropTypes.object.isRequired,
    onEmployeesLoad: PropTypes.func.isRequired,
    onChangeAnchor: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default ChangeAnchorModal;



// WEBPACK FOOTER //
// ./src/components/staffMemberManagement/changeAnchorModal/ChangeAnchorModal.js